import styled from '@emotion/styled'
import { ResetButton } from '../../common/components/ResetButton'

export const ChatPreviewIconButton = styled(ResetButton)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing.xs,
  padding: `${theme.spacing.xs}px ${theme.spacing.sm}px`,
  cursor: 'pointer',
  color: theme.colors.text.primary,
  opacity: 0.6,
  '&:hover': {
    opacity: 1,
  },
}))
